package fr.frux.feature.common

import fr.frux.core.designsystem.components.harvestPeriodLabel
import fr.frux.core.designsystem.components.untilEndOfLabel
import fr.frux.shared.domain.model.HarvestWindow

/**
 * Libellé de saison compact : "Jusqu'à fin <mois>" si une fenêtre est en cours (la plus éloignée
 * de sa fin si plusieurs se chevauchent), sinon la période de la prochaine fenêtre à venir (la
 * plus proche en mois, wrap compris). Null si aucune fenêtre.
 */
fun treeSeasonLabel(
    harvests: List<HarvestWindow>,
    currentMonth: Int,
): String? {
    if (harvests.isEmpty()) return null

    val ongoing = harvests.filter { it.isInSeason(currentMonth) }
    if (ongoing.isNotEmpty()) {
        val furthest = ongoing.maxBy { monthsForwardWrap(currentMonth, it.monthEnd) }
        return untilEndOfLabel(furthest.monthEnd)
    }

    val next = harvests.minBy { monthsForwardWrap(currentMonth, it.monthStart) }
    return harvestPeriodLabel(next.monthStart, next.monthEnd)
}

/** Nombre de mois (0..11) pour aller de [from] à [to] en avançant, avec wrap décembre→janvier. */
private fun monthsForwardWrap(
    from: Int,
    to: Int,
): Int = ((to - from) + 12) % 12
